import { useEffect } from 'react'

import SearchInput from '../SearchInput'
import { createSearchForm } from '../helpers'

type Props = {
  apiKey: string
  searchTitleText: string
  submitButtonText: string
}

function SearchPage({ apiKey, searchTitleText, submitButtonText }: Props) {
  useEffect(() => {
    createSearchForm(apiKey)
  }, [])

  return (
    <div>
      <SearchInput
        searchTitleText={searchTitleText}
        submitButtonText={submitButtonText}
        type='searchbox'
      />
      <div
        dangerouslySetInnerHTML={{
          __html: '<gcse:searchresults></gcse:searchresults>',
        }}
        id='google-custom-search-output'
      />
    </div>
  )
}

export default SearchPage
